/**
 * Each language's landing page has a URL of its own, so a search engine can
 * index all eight: English at `/`, every other language at `/<code>` — `/az`,
 * `/ru`, `/ar`… The build prerenders each one (scripts/prerender.ts) and every
 * page links the others with hreflang.
 *
 * `/` is also the page for a visitor whose language the URL does not name
 * (hreflang's x-default): there the stored preference or the browser decides,
 * as everywhere outside a plan. On `/<code>` the URL decides — without writing
 * the preference; only the language menu does that.
 *
 * index.html's first-paint script matches these paths by hand; src/prerender.test.ts
 * holds the two together.
 */

import { type LocaleCode, isLocale } from './index'

/** The production origin, for canonical and hreflang URLs. */
export const SITE = 'https://yerbeyer.com'

export function landingPath(locale: LocaleCode): string {
  return locale === 'en' ? '/' : `/${locale}`
}

/** The language a landing URL is in — null for `/`, where the visitor's language decides, and for every other path. */
export function localeFromPath(pathname: string): LocaleCode | null {
  const code = pathname.startsWith('/') ? pathname.slice(1) : ''
  return isLocale(code) && code !== 'en' ? code : null
}
